import { observable, computed } from "mobx";

import ClusterService from "../service/ClusterService";
import UserService from "../service/UserService";

export default class ClusterListModel {
    @observable clusters = [];

    constructor() {
        UserService.listenForUserChanges((err, user) => {
            if (!err && user !== null) {
                ClusterService.getAllClusters((snapshot) => {
                    if (!snapshot || !snapshot.size || snapshot.size === 0) {
                        //this.deleteCollection();
                        this.clusters = ClusterService.initCollection();
                    } else {
                        this.clusters = [];
                        this.clusterOptions = [];
                        snapshot.forEach(doc => {
                            //console.log("clusters count : %s, doc %s:%o", this.clusters.length, doc.id, doc.data());
                            this.clusters.push(doc.data());
                        });
                    }
                });
            }
        });        
    }

    // Key/Value list used in select input box
    @computed
    get ClusterOptions() {
        var optionsRegions = [{
            label: 'ALL CLUSTERS',
            value: 'ALL'
        }];
        var currGroup = '';
        this.clusters.sort(function (ob1, ob2) {
            if (ob1.region > ob2.region) {
                return 1;
            } else if (ob1.region < ob2.region) {
                return -1;
            }

            // Else go to the 2nd sort within region by name
            if (ob1.description < ob2.description) {
                return -1;
            } else if (ob1.description > ob2.description) {
                return 1;
            } else { // nothing to split them
                return 0;
            }
        }).forEach(function (item) {
            if (currGroup === '' || item.region !== currGroup) {
                currGroup = item.region;
                optionsRegions.push({ label: currGroup, value: currGroup, disabled: true });
            }
            optionsRegions.push({ value: item.name, label: item.description });
        });
        return optionsRegions;
    }

    @computed
    get Count() {
        return this.clusters.length;
    }

}


// WEBPACK FOOTER //
// ./src/models/ClusterListModel.js